import copy from '../../copy/en/shell.json' with { type: 'json' };
import { Component, type ReactNode } from "react";
import { Link } from "react-router";
import { Button } from "../components/ui/Button.js";

/** Keep navigation available when a workflow chunk or screen fails to load. */
export class PageErrorBoundary extends Component<
  {
    children: ReactNode;
    onReload?: () => void;
  },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <section className="stack" role="alert">
        <h1>{copy.PageErrorBoundary.couldNotOpenThisPage}</h1>
        <p>{copy.PageErrorBoundary.thePageDidNotFinishLoadingReload}</p>
        <div className="row">
          <Button
            variant="primary"
            onClick={this.props.onReload ?? (() => window.location.reload())}
          >{copy.PageErrorBoundary.reloadPage}</Button>
          <Link to="/" className="btn btn--secondary">{copy.PageErrorBoundary.backToWorkspace}</Link>
        </div>
        <p className="muted text-sm">{copy.PageErrorBoundary.ifThisKeepsHappeningLetYourAdministrator}</p>
      </section>
    );
  }
}
